/* @ngInject */
const data = () => {
  const self = {}

  self.myMovements = []

  return self
}

export default data



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/services/data.service.js